__webpack_require__.p = "/TweetMind-AI/";